import { INCLUDED_ITEMS } from "../data";
import { IncludedItem } from "./IncludedItem";

export const IncludedSection = () => {
  return (
    <section className="included-section">
      <div className="included-inner">
        <div className="included-title-block">
          <p className="section-label">What&apos;s included</p>
          <h2>
            Included in the <em>Professional Growth Plan</em>
          </h2>
          <p>
            Everything you need to launch, present, and manage client financing
            as a premium part of your design service.
          </p>
        </div>

        <div className="included-list">
          {INCLUDED_ITEMS.map((item) => (
            <IncludedItem key={item.title} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
};
